import { mapState } from 'vuex';
import Bus from '@/assets/js/bus.js';
export default {
  data() {
    return {
      isPipSetRotate: false,
      isSetRotate: false,
      voiceVal: 100,
      showPip: false,
      mute: false,
      isFullScreen: false,
      visible: false,
      showIconArray: true,
      fullScreenLayout: false,
      initSaveVal: true,
      showFootBar: true,
      showOperate: true,
      operateTimeOut: null
    };
  },
  props: {
    pipVolume: [String, Number],
    showOperateBox: Boolean,
    shows: Boolean,
    devicePlatform: [String, Number],
    deviceType: [String, Number],
    degreeHost: [String, Number],
    outputRtilCode: {
      type: [String, Number],
      default: ''
    },
    videoObj: {
      type: HTMLDivElement
    },
    singChannel: {
      type: Object,
      default: function () {
        return {};
      }
    },
    userInfo: {
      type: Object,
      default: function () {
        return {};
      }
    },
    muteAudioIcon: {
      type: Boolean,
      default: false
    },
    hearSelf: {
      type: Boolean,
      default: false
    },
    unSubscribe: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState({
      State: state => state,
      isMute: state => state.isMute
    }),
    showVolumeIcon() {
      let flag = false;
      if (!this.muteAudioIcon && this.hearSelf) {
        flag = true;
      }
      return flag;
    },
    returnShow() {
      // 显示的判断条件
      // 1.showOperate=true
      // 2.不能是除 party 和 kiosk 以外的模块使用
      if (!this.showOperate && this.$route.name != 'party' && this.$route.name != 'partyParticipate' && this.$route.name != 'kiosk') {
        return false;
      }
      if ((this.userInfo.owner || this.userInfo.rtilCode == this.singChannel.id) && this.devicePlatform != '70') {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    isMute: {
      immediate: true,
      handler(newVal) {
        if (newVal) {
          this.mute = true;
          this.voiceVal = 0;
        } else {
          this.mute = false;
          this.voiceVal = 100;
        }
      }
    },
    pipVolume: {
      handler: function (newVale) {
        if (this.isMute) return;
        if (newVale == undefined) return;
        this.changeVideoVolume(newVale);
      }
    },
    outputRtilCode: {
      handler: function (newVale) {
        if (newVale && this.State.partyJoinInfo.channelMode == 0) {
          this.fullScreenLayout = newVale == this.singChannel.id;
        }
      },
      immediate: true
    }
  },
  created() {
    Bus.$on('mainWindowSetting', val => {
      if (this.singChannel.id == this.outputRtilCode) {
        if (this.singChannel.shareInitiator == this.userInfo.rtilCode && this.singChannel.shareCode) return;
        if (this.isMute) return;
        this.voiceVal = val.pipVolume;
        this.changeVideoVolume(val.pipVolume);
      }
    });
    document.addEventListener('fullscreenchange', e => {
      if (!document.fullscreenElement) {
        this.visible = false;
        this.isFullScreen = false;
        this.showFootBar = true;
        this.State.showFootBar = true;
        this.$nextTick(() => {
          const parentWidth = this.$refs.controlDiv && this.$refs.controlDiv.clientWidth || 191;
          if (parentWidth <= 190) {
            this.showIconArray = false;
          }
        });
        this.$emit('callback', {
          type: 'fullScreen',
          val: false
        });
      } else {
        this.calculateBoxWidth();
      }
    });
  },
  mounted() {
    Bus.$on('changeMainwindowFullScreen', data => {
      // 目前只有 common party 与会者才有的行为，当有一个被放大，其他的就要被缩小
      const {
        value,
        id
      } = data;
      if (value) {
        if (id == this.singChannel.id) {
          this.fullScreenLayout = true;
        } else {
          this.fullScreenLayout = false;
        }
      } else {
        if (id == this.singChannel.id) {
          this.fullScreenLayout = value;
        }
      }
    });
    this.calculateBoxWidth();
  },
  methods: {
    // host页面；(镜像)控制anywhere
    hostAnywhereMirrorVideo() {
      const params = {
        partyCode: this.userInfo.parentCode,
        rtilCode: this.singChannel.id
      };
      this.axios.post('/partyline-backend/partyAction/mirrorVideo', params).then(res => {});
    },
    // 控制视频旋转
    controlVideoRotate() {
      if (!this.singChannel.id) return;
      let degrees = (Number(this.degreeHost) + 90) % 360;
      if (degrees === 360) {
        degrees = 0;
      }
      const url = this.userInfo.owner ? '/partyline-backend/partyAction/flipVideo' : '/partyline-backend/partyAction/noLogin/flipVideo';
      const params = {
        partyCode: this.userInfo.parentCode,
        rtilCode: this.singChannel.id,
        degree: degrees
      };
      this.axios.post(url, params).then(res => {
        if (res.data.errorCode === '0x0') {}
      });
    },
    setVideoAudio(audioVal) {
      if (this.singChannel.audioTrack && !this.hearSelf) {
        // 判断如果当前是自己分享的视频则不播放
        if (this.singChannel.shareInitiator == this.userInfo.rtilCode && this.singChannel.shareCode) return;
        audioVal == 0 ? this.mute = true : this.mute = false;
        if (this.singChannel.audioTrack.setVolume && !isNaN(audioVal)) {
          this.singChannel.audioTrack.setVolume(audioVal);
        }
        if (!this.initSaveVal) {
          this.$set(this.State.volumeInfo, this.singChannel.id, audioVal);
        }
        this.initSaveVal = false;
        this.$emit('callback', {
          type: 'setMute',
          val: this.mute
        });
      }
    },
    setAudio(key) {
      if (this.isMute) return;
      // 判断如果当前是自己分享的视频则不播放
      // if (this.singChannel.shareInitiator == this.userInfo.rtilCode && this.singChannel.shareCode) return
      if (this.singChannel.audioTrack) {
        if (key === 'mute') {
          this.mute = true;
          this.voiceVal = 0;
          this.singChannel.audioTrack.setVolume(0);
        } else {
          this.mute = false;
          this.voiceVal = 100;
          this.singChannel.audioTrack.setVolume(100);
        }
        this.$set(this.State.volumeInfo, this.singChannel.id, this.voiceVal);
        this.$emit('callback', {
          type: 'setMute',
          val: this.mute
        });
      }
    },
    changeVideoVolume(val) {
      if (val == undefined) return;
      this.voiceVal = val;
      if (this.singChannel.audioTrack && !isNaN(val)) {
        this.singChannel.audioTrack.setVolume(val);
      }
    },
    setPictureInpicture() {
      this.showPip = false;
      this.visible = false;
      // 判断当前source是否是自己
      if (this.userInfo.rtilCode == this.singChannel.id) {
        if (document.getElementById('local_stream') && document.getElementById('local_stream').children) {
          try {
            const video = document.getElementById('local_stream').children[0].children[0];
            if (video.readyState >= 3) {
              var _document$getElementB, _document$getElementB2;
              (_document$getElementB = (_document$getElementB2 = document.getElementById('local_stream').children[0].children[0]).requestPictureInPicture) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.call(_document$getElementB2);
            }
          } catch (e) {
            console.log(e);
          }
        }
      } else {
        try {
          var _this$videoObj, _this$videoObj$childr, _this$videoObj$childr2, _this$videoObj$childr3;
          const video = (_this$videoObj = this.videoObj) === null || _this$videoObj === void 0 ? void 0 : (_this$videoObj$childr = _this$videoObj.children) === null || _this$videoObj$childr === void 0 ? void 0 : (_this$videoObj$childr2 = _this$videoObj$childr[0]) === null || _this$videoObj$childr2 === void 0 ? void 0 : (_this$videoObj$childr3 = _this$videoObj$childr2.children) === null || _this$videoObj$childr3 === void 0 ? void 0 : _this$videoObj$childr3[0];
          if (video && video.readyState >= 3) {
            var _video$requestPicture;
            (_video$requestPicture = video.requestPictureInPicture) === null || _video$requestPicture === void 0 ? void 0 : _video$requestPicture.call(video);
          }
        } catch (e) {
          console.log(e);
        }
      }
    },
    fullScreen(val) {
      this.isFullScreen = typeof val == 'number' ? val : !this.isFullScreen;
      if (!this.isFullScreen) {
        this.showFootBar = true;
        this.State.showFootBar = true;
      }
      const parentWidth = this.$refs.controlDiv && this.$refs.controlDiv.clientWidth || 191;
      if (parentWidth <= 190) {
        if (this.isFullScreen) {
          this.showIconArray = true;
        } else {
          this.showIconArray = false;
        }
      }
      this.$emit('callback', {
        type: 'fullScreen',
        val: this.isFullScreen
      });
    },
    controlFootBar() {
      this.showFootBar = !this.showFootBar;
      this.State.showFootBar = !this.State.showFootBar;
      if (!this.showFootBar) {
        this.$emit('callback', {
          type: 'mouseMove'
        });
      } else {
        this.$emit('callback', {
          type: 'removeMouseMove'
        });
      }
    },
    switchFullScreen() {
      this.fullScreenLayout = !this.fullScreenLayout;
      if (this.isFullScreen && this.fullScreenLayout) {
        this.isFullScreen = false;
        this.$emit('callback', {
          type: 'fullScreen',
          val: this.isFullScreen
        });
      }
      this.$emit('callback', {
        type: 'switchFullScreen',
        val: this.fullScreenLayout,
        pipInfo: this.singChannel,
        volume: this.voiceVal
      });
    },
    changeFullScreenVal(val) {
      this.fullScreenLayout = val;
    },
    calculateBoxWidth() {
      if (this.$refs.controlDiv && this.$route.name == 'group') {
        // 计算当前父盒子的宽度，如果过小的话隐藏 iconList 显示三个点
        const parentWidth = this.$refs.controlDiv.clientWidth && this.$refs.controlDiv.clientWidth || 191;
        if (parentWidth <= 190) {
          this.showIconArray = false;
        } else {
          this.showIconArray = true;
        }
      }
    },
    changeIsFullScreenVal(val) {
      this.isFullScreen = val;
    }
  },
  beforeDestory() {
    Bus.$off('changeMainwindowFullScreen');
    if (this.operateTimeOut) {
      clearTimeout(this.operateTimeOut);
    }
  }
};